/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum PlaybackState {
    RW3 = 'RW3',
    RW2 = 'RW2',
    RW1 = 'RW1',
    PAUSE = 'PAUSE',
    PLAY = 'PLAY',
    FF1 = 'FF1',
    FF2 = 'FF2',
    FF3 = 'FF3',
    STOP = 'STOP',
}
